
import { mapGetters, mapState } from 'vuex'
export default {
    props: {
        item: {
            type: [Array, Object],
            default: () => {},
        },
        accountHolderName: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            bankButtonLoading: false,
            editDialog: false,
            formData: {},
            formValid: false,
            supportedCurrencyList: [],
            updateBankAccountLoading: false,
            bankOptionSelection: 1,
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
            operationSetting: (state) => state.settings.operationSetting,
        }),
        ...mapGetters({
            banks: 'banks/banks',
        }),
        formRule() {
            return {
                bank_id: [
                    (v) =>
                        !!v ||
                        `${this.tr(this.FRONTEND_ERROR_CODES.bankIsRequired)}`,
                ],
                account_holder_name: [
                    (v) =>
                        !!v ||
                        `${this.tr(
                            this.FRONTEND_ERROR_CODES
                                .bankAccountHolderNameIsRequired
                        )}`,
                ],
                bank_account_number: [
                    (v) =>
                        !!v ||
                        `${this.tr(
                            this.FRONTEND_ERROR_CODES.accountNumberIsRequired
                        )}`,
                    (v) =>
                        /^[\d\s]+$/.test(v) ||
                        `${this.tr(
                            this.FRONTEND_ERROR_CODES
                                .accountNumberShouldContainOnlyNumber
                        )}`,
                ],
                bank_name: [
                    (v) =>
                        !!v ||
                        `${this.tr(
                            this.FRONTEND_ERROR_CODES.bankNameIsRequired
                        )}`,
                ],
            }
        },
    },
    watch: {
        async editDialog(value) {
            if (value) {
                if (this.banks.length === 0) {
                    await this.$store.dispatch('banks/banks', {
                        country_code: this.player.country_code,
                    })
                }
            }
        },
    },
    methods: {
        getLimitedName(text) {
            if (!text) return null
            const displayLimit = 30
            if (text.length > displayLimit) {
                return text.substring(0, displayLimit) + '...'
            } else {
                return text
            }
        },
        async onDeleteBank(id) {
            if (!window.confirm(`${this.tl('areYouSureToDelete')}?`))
                return null
            this.bankButtonLoading = true
            await this.$store.dispatch(
                'themes/player-bank/doDeletePlayerBankAccount',
                id
            )
            this.bankButtonLoading = false
        },
        async onSetPrimary(id) {
            this.bankButtonLoading = true
            const form = { is_primary: true }
            await this.$store.dispatch(
                'themes/player-bank/doUpdatePlayerBankAccount',
                { form, accountId: id }
            )
            this.bankButtonLoading = false
        },
        onEditBank() {
            this.editDialog = true
            this.onChangeBank(this.item.bank_id)
            this.formData = {}
            this.formData.bank_currency = this.item.currency
            this.formData.bank_branch = this.item.bank_branch
            this.formData.bank_account_number = this.item.bank_account_number
            if (this.item?.bank_id) {
                this.formData.bank_id = this.item.bank_id
                this.bankOptionSelection = 1
            } else {
                this.formData.bank_name = this.item.player_bank_name
                this.bankOptionSelection = 2
            }
        },
        async onChangeBank(bankId) {
            // This function is for getting bank supported currency
            if (this.banks.length === 0) {
                await this.$store.dispatch('banks/banks', {
                    country_code: this.player.country_code,
                })
            }
            const bank = this.banks.find((el) => el.id === bankId)
            if (!bank) {
                this.supportedCurrencyList = []
                return null
            }
            const { supported_currency: supportedCurrency } = bank
            this.supportedCurrencyList = supportedCurrency

            if (this.supportedCurrencyList.length > 0) {
                this.formData.bank_currency = this.supportedCurrencyList[0]
            }
        },
        async onUpdateBankAccount() {
            this.$refs?.refBank?.validate()
            if (!this.formValid) return
            this.updateBankAccountLoading = true
            if (this.bankOptionSelection === 2) {
                delete this.formData.bank_id
            } else {
                delete this.formData.bank_name
            }
            if (this.player?.name) delete this.formData.account_holder_name
            const result = await this.$store.dispatch(
                'themes/player-bank/doUpdatePlayerBankAccount',
                {
                    form: { ...this.formData },
                    accountId: this.item.id,
                }
            )
            this.updateBankAccountLoading = false
            if (result) {
                this.$toast.success(this.tl('updateBankAccountSuccessful'))
                this.$refs.refBank.reset()
                this.editDialog = false
            }
        },
    },
}
